import { useId } from '@floating-ui/react-dom-interactions'
import cx from 'classnames'
import { ComponentProps } from 'react'
import { CodeSnippet } from '../components'

type Props = {
  label?: React.ReactNode
  value: string
  description: string
  obfuscated?: boolean
} & ComponentProps<'div'>

export const Copy = (props: Props) => {
  const id = useId()
  const { label, value, description, className } = props
  return (
    <div {...props} className={cx('overflow-hidden', className)}>
      {label && (
        <div className={cx('mb-1 text-sm text-gray-11')}>
          <label htmlFor={id}>{label}</label>
        </div>
      )}
      <CodeSnippet code={value} description={description} className="border-2 border-dashed hover:border-accent-9" />
    </div>
  )
}
